import React from 'react';
import { useSelector } from 'react-redux';
import { Dealer } from '@upstart/harmony/lib/legos/dealerTypes';
import { Condition } from '@upstart/harmony/lib/legos/constants';
import ErrorMessage from '../../../ErrorMessage';
import TiersDefinition from './TiersDefinition';
import TiersPurchase from './TiersPurchase';
import TiersLease from './TiersLease';
import TiersOptions from './TiersOptions';
import { AprConfigResultProps } from '../useAprConfig';

export interface TiersContainerProps extends AprConfigResultProps {
  condition: Condition;
}

function TiersContainer({
  condition,
  tieredAprConfig,
  validationResult,
  onTiersDefinitionsUpdate,
  onTiersDefinitionAdd,
  onTiersDefinitionRemove,
  onTiersDefinitionCopy,
  onTiersPurchasePartialUpdate,
  onTiersLeasePartialUpdate,
  onTiersOptionsPartialUpdate,
}: TiersContainerProps) {
  // @ts-ignore
  const dealer: Dealer = useSelector(state => state.dealers.dealer);
  const onePayLeaseEnabled = dealer.desking?.enableOnePayLease || false;

  if (!tieredAprConfig) return null;

  const renderErrors = () => (
    <>
      <ErrorMessage error="Please resolve validation error highlighted in red." />
      <strong style={{ marginLeft: '10px' }}>
        Make sure that fields are defined and there are no duplicates terms or
        mileages.
      </strong>
    </>
  );

  return (
    <>
      {validationResult?.success ? null : renderErrors()}

      <TiersDefinition
        condition={condition}
        lease={tieredAprConfig.tiers.lease || []}
        purchase={tieredAprConfig.tiers.purchase || []}
        validationResult={validationResult}
        onTiersDefinitionsUpdate={onTiersDefinitionsUpdate}
        onTiersDefinitionCopy={onTiersDefinitionCopy}
        onTiersDefinitionAdd={onTiersDefinitionAdd}
        onTiersDefinitionRemove={onTiersDefinitionRemove}
      />
      <TiersPurchase
        purchase={tieredAprConfig.pricing.purchase}
        options={tieredAprConfig.options}
        validationResult={validationResult}
        onTiersPurchasePartialUpdate={onTiersPurchasePartialUpdate}
      />
      {condition === Condition.NEW && (
        <TiersLease
          onePayLeaseEnabled={onePayLeaseEnabled}
          lease={tieredAprConfig.pricing.lease}
          validationResult={validationResult}
          onTiersLeasePartialUpdate={onTiersLeasePartialUpdate}
        />
      )}
      <TiersOptions
        condition={condition}
        aprConfig={tieredAprConfig}
        validationResult={validationResult}
        onTierOptionsPartialUpdate={onTiersOptionsPartialUpdate}
      />
    </>
  );
}

export default TiersContainer;
